export default __webpack_public_path__ + "static/media/layout-1 (5).c743de07.jpg";